import React from 'react';
import Select from '../Select';

import classNames from 'classnames';

let trackTimer;

class CurrencyCalculator extends React.Component {
    state = {
        formValues: {
            currency: this.props.activeCurrency.toUpperCase(),
            sekAmount: '',
            convertedAmount: ''
        }
    }

    options = []

    constructor(props) {
        super(props);

        // setup select options
        this.options = this.props.rates.map(item => (
            {
                label: `${this.props.currencyCountryMap[item.currency.toLowerCase()]} - ${item.currency.toUpperCase()}`,
                value: item.currency
            }
        ));
    }

    trackInputChange(curr) {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            inputCurrency: curr,
            event: "currencyConversion"
        });
    }

    formatDecimals(value, dec) {
        return value === 0
            ? 0
            : Number.isInteger(value)
                ? parseInt(value)
                : value.toFixed(dec);
    }

    handleInputChange = (event) => {
        const inputName = event.target.name;
        const value = event.target.value.replace(/[^0-9]/g, '');

        const currency = this.state.formValues.currency;
        const exchangeRate = this.props.rates.find(
            item => item.currency.toLowerCase() === currency.toLowerCase()
        );

        clearTimeout(trackTimer);
        trackTimer = setTimeout(this.trackInputChange, 2000, currency);


        if (inputName === 'sekAmount') {
            const convertedAmount = value * 1 / (exchangeRate.rate / exchangeRate.unit);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    sekAmount: value,
                    convertedAmount: this.formatDecimals(convertedAmount, 2)
                }
            });
        } else {
            const sekAmount = value * (exchangeRate.rate / exchangeRate.unit);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    sekAmount: this.formatDecimals(sekAmount, 2),
                    convertedAmount: value
                }
            });
        }
    }

    handleSelectChange = (event) => {
        const value = event.target.value;
        const exchangeRate = this.props.rates.find(
            item => item.currency.toLowerCase() === value.toLowerCase()
        );
        const sekAmount = this.state.formValues.sekAmount;
        const convertedAmount = sekAmount * 1 / (exchangeRate.rate / exchangeRate.unit);

        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            changeCurrency: value,
            event: "currencyChange"
        });

        window.dispatchEvent(new CustomEvent('bankomatFilterChange', {
            detail: {
                filter: value
            }
        }));

        this.setState({
            formValues: {
                ...this.state.formValues,
                currency: value,
                convertedAmount: this.formatDecimals(convertedAmount, 2)
            }
        });
    };

    render() {
        const { title, rates, currencyCountryMap, link, labels } = this.props;
        let HeadingTag = '';

        if(this.props.tag == 'h1') HeadingTag = `h1`;
        else if(this.props.tag == 'h2') HeadingTag = `h2`;
        else HeadingTag = `h3`;

        const currency = this.state.formValues.currency;
        const exchangeRateObject = rates.find(item => item.currency.toLowerCase() === currency.toLowerCase());
        if (!exchangeRateObject) {
            return null;
        }

        const exchangeRate = exchangeRateObject.rate / exchangeRateObject.unit;

        const toCurrencyFlagClasses = classNames('CurrencyCalculator__Flag', {
            [`CurrencyCalculator__Flag--${currency.toUpperCase()}`]: currency
        });

        return (
            <div className="CurrencyCalculator">
                <HeadingTag className="CurrencyCalculator__Heading">{title}</HeadingTag>
                <div className="CurrencyCalculator__OuterContainer">
                    <div className="CurrencyCalculator__Container">
                        <p className="CurrencyCalculator__Label">
                            {labels.whereAndHowMuch}
                        </p>

                        <Select
                            name="currency"
                            label="Välj valuta"
                            options={this.options}
                            value={this.state.formValues.currency}
                            onChange={this.handleSelectChange}
                        />

                        <div>
                            <div className="CurrencyCalculator__CountryContainer">
                                <div className="CurrencyCalculator__Flag CurrencyCalculator__Flag--SEK">
                                </div>
                                <label
                                    htmlFor="sekAmount"
                                    className="CurrencyCalculator__CountryLabel"
                                >
                                    <span className="CurrencyCalculator__CountryLabel__Country">
                                        {currencyCountryMap.sek}&nbsp;
                                    </span>
                                    <span className="CurrencyCalculator__CountryLabel__Currency">
                                        SEK
                                    </span>
                                </label>
                                <div className="CurrencyCalculator__InputContainer">
                                    <input
                                        type="text"
                                        name="sekAmount"
                                        className="CurrencyCalculator__Input"
                                        placeholder={labels.placeholderTxt}
                                        onChange={this.handleInputChange}
                                        onFocus={(e) => e.target.placeholder = ""}
                                        onBlur={(e) => e.target.placeholder = labels.placeholderTxt}
                                        value={this.state.formValues.sekAmount}
                                    />
                                </div>
                            </div>

                            <div className="CurrencyCalculator__CountryContainer">
                                <div className={toCurrencyFlagClasses}>
                                </div>
                                <label
                                    htmlFor="convertedAmount"
                                    className="CurrencyCalculator__CountryLabel"
                                >
                                    <span className="CurrencyCalculator__CountryLabel__Country">
                                        {currencyCountryMap[currency.toLowerCase()]}&nbsp;
                                    </span>
                                    <span className="CurrencyCalculator__CountryLabel__Currency">
                                        {currency.toUpperCase()}
                                    </span>
                                </label>
                                <div className="CurrencyCalculator__InputContainer">
                                    <input
                                        type="text"
                                        name="convertedAmount"
                                        className="CurrencyCalculator__Input"
                                        onChange={this.handleInputChange}
                                        onFocus={(e) => e.target.placeholder = ""}
                                        onBlur={(e) => e.target.placeholder = labels.placeholderTxt}
                                        placeholder={labels.placeholderTxt}
                                        value={this.state.formValues.convertedAmount}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="CurrencyCalculator__Rate">
                            <span className="CurrencyCalculator__Label">
                                {labels.exchangeRate}
                            </span>
                            <span className="CurrencyCalculator__RateLabel">
                                1 {currency.toUpperCase()} = {exchangeRate.toFixed(4)} SEK
                            </span>
                        </div>

                        {link &&
                            <div className="CurrencyCalculator__Link">
                                <a className="button" href={link.url}>{link.title}</a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

CurrencyCalculator.defaultProps = {
    title: '',
    tag: '',
    rates: [],
    labels: {},
    link: {},
    currencyCountryMap: {}
}

export default CurrencyCalculator;
